import { useProfileQuery } from 'v2/pages/settings/queries'
import { useFeatureFlags } from './use-feature-flags'

const LIVEKIT_AUTO_ENABLE_CUTOFF = '2026-04-27'

export const useLivekitEnabled = () => {
  const { isLivekitEnabled: flagEnabled, isInitialData: isFeatureFlagsLoading } = useFeatureFlags()
  const { data: profile, isLoading: isProfileLoading } = useProfileQuery()

  const orgCreatedAt = profile?.organizations?.[0]?.org_created_at
  // org_created_at format: "YYYY-MM-DD HH:mm:ss". Fixed-width date prefix lets us
  // string-compare against a YYYY-MM-DD cutoff without timezone-parsing ambiguity.
  const isPostCutoffOrg = orgCreatedAt ? orgCreatedAt >= LIVEKIT_AUTO_ENABLE_CUTOFF : false

  return {
    isLivekitEnabled: flagEnabled || isPostCutoffOrg,
    isLoading: isFeatureFlagsLoading || (!flagEnabled && isProfileLoading),
  }
}
